module.exports = __webpack_public_path__ + "img/LUB00177.75bffe08.png";